import { useQuery } from '@tanstack/react-query';
import { IPostcode } from '../../Interfaces/IPostcode';
import { customFetcher } from '../useFetch';

export const useSearchPostcodes = (searchTerm?: string) => {
  const abortController = new AbortController();

  const searchTermTrimmed = searchTerm?.trim();

  const { data: postcodes, isLoading: isLoadingPostcodes } = useQuery<
    IPostcode[]
  >({
    refetchOnWindowFocus: false,
    queryKey: ['postcode', 'search', searchTermTrimmed],
    queryFn: () =>
      customFetcher({
        endpoint: `/postcode/search/${searchTermTrimmed}`,
        signal: abortController.signal,
      }),
    // Only search if the search term is not empty and has more than 2 characters to avoid unnecessary requests
    enabled: !!searchTermTrimmed && searchTermTrimmed.length >= 2,
  });

  const abort = () => {
    if (isLoadingPostcodes) {
      abortController.abort();
    }
  };

  return { postcodes, isLoadingPostcodes, abortSearchPostcodes: abort };
};

export const useGetPostcode = (currentId: number | null) => {
  const { data: postcode, isLoading: isLoadingPostcode } = useQuery<IPostcode>({
    queryKey: ['postcode', currentId],
    queryFn: () => customFetcher({ endpoint: `/postcode/${currentId}` }),
    refetchOnWindowFocus: false,
    enabled: !!currentId, // nur wenn Boolean true und ID gültig
  });

  return { postcode, isLoadingPostcode };
};
